<app-page-content>
    <div class="layout">
        <div class="mx-5 px-2 mt-2">
            <ng-content></ng-content>
        </div>
    </div>
</app-page-content>